module.exports = __webpack_public_path__ + "static/media/Project3_Fig13.543c7710.png";